// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import SelectState from 'client/components/form/selectState';
import Select from 'client/components/form/select';

import '../../styles/contentFilter.scss';

export type ContentInputType = {
  type: string,
  inputGroupProps: Object,
};

export type ContentItemType = {
  [key: string]: string,
  content: React$Element<*>,
};

type Props = {
  changeHandler: Function,
  className: string,
  defaultShowAll: boolean,
  defaultValue: string,
  description: string,
  filterByKey: Object,
  header: string,
  input: ContentInputType,
  items: Array<ContentItemType>,
};

type State = {
  inputValue: string,
};

const INPUT_TYPE = {
  SELECT_STATE: 'SelectState',
  SELECT: 'Select',
};

class ContentFilter extends Component<Props, State> {
  static defaultProps = {
    changeHandler: () => {},
    className: '',
    defaultValue: '',
    defaultShowAll: false,
    header: '',
    input: {
      type: '',
      inputGroupProps: {},
    },
    items: [],
  };

  state = {
    inputValue: this.props.defaultValue || '',
  };

  handleValueChange = (value: string) => {
    this.setState({
      inputValue: value,
    });
    this.props.changeHandler(value);
  };

  // Only add 'SelectState' input type here since it is the only use case for now.
  renderInputField = () => {
    const {
      input: { type, inputGroupProps },
    } = this.props;
    const { inputValue } = this.state;
    let inputField = null;

    switch (type) {
      case INPUT_TYPE.SELECT_STATE:
        inputField = (
          <SelectState
            {...inputGroupProps}
            value={inputValue}
            changeHandler={this.handleValueChange} />
        );
        break;
      case INPUT_TYPE.SELECT:
        inputField = (
          <Select {...inputGroupProps} value={inputValue} changeHandler={this.handleValueChange} />
        );
        break;
      default:
        break;
    }

    return inputField;
  };

  renderFilteredChildren = () => {
    const { defaultShowAll, filterByKey, items } = this.props;
    const { inputValue } = this.state;
    const noFilter = !inputValue && defaultShowAll;
    const filteredItems = noFilter ? items : _.filter(items, { [filterByKey]: inputValue });

    return (
      <div className="filtered-content">
        {!_.isEmpty(filteredItems) &&
          _.map(filteredItems, item => (
            <React.Fragment key={item.key}>{item.content}</React.Fragment>
          ))}
      </div>
    );
  };

  render() {
    const { header, description, className } = this.props;

    return (
      <div className={`content-filter-container ${className}`}>
        {header && <div className="header pad-bottom">{header}</div>}
        {description && <div>{description}</div>}
        {this.renderInputField()}
        {this.renderFilteredChildren()}
      </div>
    );
  }
}

export default ContentFilter;
